import SegmentedProgress from "./segmented";
import { Map } from "lucide-react";

import * as S from "./styles";

const TopoMain = ({ totalStep, atualStep, cliente, totem }) => {
  return (
    <S.DetailInlineBox>
      <S.DetailInlineBoxItem>
        <Map />
      </S.DetailInlineBoxItem>
      {!cliente.ok && !!totem && !!totem.nome && (
        <S.DetailInlineBoxItem>
          <S.Destaque>Totem {totem.nome}</S.Destaque>
        </S.DetailInlineBoxItem>
      )}
      {!!cliente.ok && !!totem && !!totem.nome && (
        <S.DetailInlineBoxItem>
          <S.Texto2>Totem {totem.nome}</S.Texto2>
          <S.Texto3>Olá, {cliente.nome}</S.Texto3>
        </S.DetailInlineBoxItem>
      )}
      <S.DetailInlineBoxItem>
        <SegmentedProgress totalBlocks={totalStep} currentProgress={atualStep} />
      </S.DetailInlineBoxItem>
    </S.DetailInlineBox>
  );
};

export default TopoMain;
